<template>
	<section :class="`section organisations-to-follow ${bgcolor}`" v-if="organisations">
    <div class="container flex flex-wrap items-center px-4 mx-auto">

			<div class="mb-4 section-title__wrapper">

				<h3 class="section-title">
					<template v-if="me">
						Organisations matched to&nbsp;you
					</template>
					<template v-else>
						Organisations to follow.
					</template>
				</h3>

			</div>

			<div class="organisation-cards org-cards">
				<template v-for="(organisation, o) in organisations" :key="o">
          <block-org-card :payload="organisation"></block-org-card>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
	import RecommendedOrgs from '@/mixins/RecommendedOrgs';

	export default {
		mixins: [RecommendedOrgs],
		props: {
			bgcolor: {
				type: String,
				default: 'bg-white'
			}
		},

		data() {
			return {
				organisations: false
			}
		},
		created() {
			this.emitter.on('refresh:recommended:orgs',this.refreshOrgs);
		},
		beforeUnmount() {
			this.emitter.off('refresh:recommended:orgs',this.refreshOrgs);
		},
		mounted() {

		},
		methods: {
			refreshOrgs(orgs) {
				console.log(orgs);
				this.shuffleArray(orgs);
				this.organisations = orgs.slice(0, 3);
			},
			shuffleArray(array) {
				for (let i = array.length - 1; i > 0; i--) {
					const j = Math.floor(Math.random() * (i + 1));
					[array[i], array[j]] = [array[j], array[i]]; // Swap elements
				}
			}
		},
		computed: {

		}

	}
</script>
